import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { useContent } from "@/content/ContentContext";
import { useLang } from "@/i18n/LanguageContext";

const ease = [0.22, 1, 0.36, 1];

export default function News() {
  const content = useContent();
  const { t } = useLang();
  const updates = content.updates;
  return (
    <section
      id="updates"
      data-testid="updates-section"
      className="border-t border-line bg-moss/40"
    >
      <div className="mx-auto max-w-[1440px] px-6 py-28 lg:px-12 lg:py-40">
        <motion.p
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.7, ease }}
          className="text-xs uppercase tracking-[0.3em] text-harvest"
        >
          {t("updatesOverline")}
        </motion.p>
        <motion.h2
          initial={{ opacity: 0, y: 32 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.8, delay: 0.1, ease }}
          data-testid="updates-heading"
          className="mt-6 font-display text-4xl font-medium leading-[1.05] tracking-tight text-cream sm:text-5xl"
        >
          {t("updatesHeadA")} <span className="italic text-harvest">{t("updatesHeadAccent")}</span>
        </motion.h2>

        <div className="mt-16">
          {updates.map((u, i) => (
            <motion.div
              key={u.title}
              initial={{ opacity: 0, y: 32 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.8, delay: i * 0.08, ease }}
              data-testid={`update-row-${i}`}
              className="group grid items-center gap-4 border-t border-line py-8 last:border-b sm:grid-cols-12 sm:gap-8"
            >
              <p className="text-xs uppercase tracking-[0.2em] text-sage sm:col-span-2">
                {u.date}
              </p>
              <div className="sm:col-span-2">
                <span className="inline-block border border-line px-3 py-1 text-[11px] uppercase tracking-[0.15em] text-harvest">
                  {u.tag}
                </span>
              </div>
              <h3 className="font-display text-xl font-medium leading-snug tracking-tight text-cream transition-colors duration-300 group-hover:text-harvest sm:col-span-7 sm:text-2xl">
                {u.title}
              </h3>
              <div className="hidden justify-end sm:col-span-1 sm:flex">
                <ArrowUpRight className="h-5 w-5 text-sage transition-all duration-300 group-hover:-translate-y-0.5 group-hover:translate-x-0.5 group-hover:text-harvest" />
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
